import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import PdfPreview from "../../../Common/PDFPreview";
import { RingLoader } from 'react-spinners';
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount"
import BackButton from "../../../Common/Buttons/BackButton";

const API_URL = process.env.REACT_APP_API;

const StockBookReport = () => {
  const location = useLocation();
  // const { itemCode,fromDate, toDate } = location.state;
  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const companyName = sessionStorage.getItem('Company_Name')

  const searchParams = new URLSearchParams(location.search);
  const itemCode = searchParams.get('itemCode');
  const godawncode = searchParams.get('godawnCode');

  const toDate = searchParams.get('toDate');
  const fromDate = searchParams.get('fromDate');

  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(true);
  const [pdfPreview, setPdfPreview] = useState([])
  const [showPreview, setShowPreview] = useState(false);

  const navigate = useNavigate();

  const groupBy = (array, key) => {
    const grouped = array.reduce((result, currentItem) => {
      const groupKey = currentItem[key];
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(currentItem);
      return result;
    }, {});

    const sortedKeys = Object.keys(grouped).sort((a, b) =>
      a.localeCompare(b)
    );

    const sortedGrouped = {};
    sortedKeys.forEach((key) => {
      sortedGrouped[key] = grouped[key];
    });

    return sortedGrouped;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  useEffect(() => {
    debugger;
    const fetchStockBookReport = async () => {
      try {
        const response = await fetch(
          `${API_URL}/report-stock-book?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}&ToDate=${toDate}&Year_Code=${Year_Code}&godawn_Code=${godawncode} `
        );
        const result = await response.json();
        const filteredData = result.data.filter((item) => {
          const docDate = new Date(item.doc_date);
          const from = new Date(fromDate);
          const to = new Date(toDate);
          return docDate >= from && docDate <= to;
        });

        const grouped = filteredData.reduce((acc, item) => {
          const godown = item.godawnname || "Unknown Godown";
          const itemName = item.item_name || "Unknown Item";

          // Create Godown Group
          if (!acc[godown]) {
            acc[godown] = {};
          }

          // Create Item Group inside Godown
          if (!acc[godown][itemName]) {
            acc[godown][itemName] = [];
          }

          acc[godown][itemName].push(item);

          return acc;
        }, {});

        setGroupedData(grouped);

        // const grouped = groupBy(filteredData, "item_name");
        // setGroupedData(grouped);
      } catch (error) {
        console.error("Error fetching stock book report:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStockBookReport();
  }, [toDate]);

  const handleBack = () => {
    navigate('/stock-book')
  }

  const generatePDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;
    const margin = 10;
    const pageWidth = doc.internal.pageSize.width;

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    const companyNameWidth = doc.getTextWidth(companyName || "Company Name");
    const companyNameX = (pageWidth - companyNameWidth) / 2;
    doc.text(companyName, companyNameX, 10);

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const titleWidth = doc.getTextWidth("Stock Book Report");
    const titleX = (pageWidth - titleWidth) / 2;
    doc.text("Stock Book Report", titleX, 18);

    doc.setFontSize(10);
    const dateRangeText = `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`;
    const dateRangeWidth = doc.getTextWidth(dateRangeText);
    const dateRangeX = (pageWidth - dateRangeWidth) / 2;
    doc.text(dateRangeText, dateRangeX, 24);

    let currentY = 34;
    Object.keys(groupedData).forEach((group, groupIndex) => {
      if (currentY + 20 > pageHeight - margin) {
        doc.addPage();
        currentY = margin;
      }

      doc.setFontSize(12);
      doc.setTextColor(40);

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      const titleWidth = doc.getTextWidth("Stock Book Report");
      const titleX = (pageWidth - titleWidth) / 2
      doc.text(`Item Name: ${group.toUpperCase()}`, titleX, currentY);
      currentY += 10;

      const tableData = groupedData[group].map((row) => [
        formatDate(row.doc_date),
        formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
      ]);


      const totalRow = [
        "Total",
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.op_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.op_value) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.close_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(groupedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.close_val) || 0), 0)
          .toFixed(2)),
      ];


      doc.autoTable({
        startY: currentY,
        head: [
          [
            "Date",
            "Opening Qty",
            "Opening Value",
            "Purchase Qty",
            "Purchase Value",
            "Sale Qty",
            "Sale Value",
            "Closing Qty",
            "Closing Value",
          ],
        ],
        body: [...tableData, totalRow],
        styles: { fontSize: 8, cellPadding: 3, halign: "right" },
        headStyles: { fillColor: [240, 240, 240], textColor: 0 },
        columnStyles: { 0: { halign: "center" } },
        didDrawPage: (data) => {
          currentY = data.cursor.y;
        },
      });

      currentY = doc.lastAutoTable.finalY + 10;
    });

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setPdfPreview(pdfUrl);
    setShowPreview(true);
  };

  if (loading) return <div>{loading && (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <RingLoader />
    </div>
  )}
  </div>;

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div className="d-flex mb-3 mt-0.5">
        <BackButton onClick={handleBack} />
        {showPreview && pdfPreview && (
          <PdfPreview pdfData={pdfPreview} apiData={groupedData} label={"Stock-Report"} />
        )}
        <button
          onClick={generatePDF}
          className="print-button"
          style={{ fontSize: "16px", height: "50px", marginTop: "10px" }}
        >
          PDF Preview
        </button>
      </div>
      <h2 style={{ textAlign: "center", marginBottom: "5px", color: "#333", marginTop: "-60px" }}>
        {companyName}
      </h2>
      <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
        <strong>Stock Book Report From Date:</strong> {formatDate(fromDate)} |{" "}
        <strong>To Date:</strong> {formatDate(toDate)}
      </p>
      {Object.keys(groupedData).map((godown, index) => (
        <div key={index} style={{ marginBottom: "30px" }}>

          {/* Godown Heading */}
          <h3
            style={{
              backgroundColor: "#d9edf7",
              padding: "10px",
              textAlign: "left",
            }}
          >
            GODOWN : {godown.toUpperCase()}
          </h3>

          {/* Item Wise Loop */}
          {Object.keys(groupedData[godown]).map((group, groupIndex) => (
            <div key={groupIndex} style={{ marginBottom: "25px" }}>

              {/* Item Heading */}
              <h4
                style={{
                  backgroundColor: "#f4f4f4",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                ITEM : {group.toUpperCase()}
              </h4>

              <table
                border="1"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px",
                }}
              >
                <thead>
                  <tr>
                    <th rowSpan="2" style={{ textAlign: "center", padding: "10px" }}>
                      Date
                    </th>

                    <th colSpan="2" style={{ textAlign: "center", padding: "10px" }}>
                      Opening
                    </th>

                    <th colSpan="2" style={{ textAlign: "center", padding: "10px" }}>
                      Purchase
                    </th>

                    <th colSpan="2" style={{ textAlign: "center", padding: "10px" }}>
                      Sale
                    </th>

                    <th colSpan="2" style={{ textAlign: "center", padding: "10px" }}>
                      Closing
                    </th>

                    <th style={{ textAlign: "center", padding: "10px" }}>
                      Day Diff
                    </th>
                  </tr>

                  <tr>
                    <th style={{ textAlign: "right", padding: "10px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "10px" }}>Value</th>

                    <th style={{ textAlign: "right", padding: "10px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "10px" }}>Value</th>

                    <th style={{ textAlign: "right", padding: "10px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "10px" }}>Value</th>

                    <th style={{ textAlign: "right", padding: "10px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "10px" }}>Value</th>

                    <th style={{ textAlign: "center", padding: "10px" }}>
                      Quantity
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {groupedData[godown][group].map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      style={{
                        backgroundColor:
                          rowIndex % 2 === 0 ? "#f9f9f9" : "white",
                      }}
                    >
                      <td style={{ textAlign: "center" }}>
                        {formatDate(row.doc_date)}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.op_qty) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.op_value) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.purc_qty) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.purc_value) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.sale_qty) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.sale_val) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.close_qty) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "right" }}>
                        {formatReadableAmount(
                          (parseFloat(row.close_val) || 0).toFixed(2)
                        )}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {formatReadableAmount(
                          (
                            (parseFloat(row.purc_qty) || 0) -
                            (parseFloat(row.sale_qty) || 0)
                          ).toFixed(2)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot
                  style={{
                    backgroundColor: "#e0e0e0",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td style={{ textAlign: "center" }}>Total</td>

                    <td></td>
                    <td></td>

                    <td style={{ textAlign: "right" }}>
                      {formatReadableAmount(
                        groupedData[godown][group]
                          .reduce(
                            (sum, item) =>
                              sum + (parseFloat(item.purc_qty) || 0),
                            0
                          )
                          .toFixed(2)
                      )}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {formatReadableAmount(
                        groupedData[godown][group]
                          .reduce(
                            (sum, item) =>
                              sum + (parseFloat(item.purc_value) || 0),
                            0
                          )
                          .toFixed(2)
                      )}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {formatReadableAmount(
                        groupedData[godown][group]
                          .reduce(
                            (sum, item) =>
                              sum + (parseFloat(item.sale_qty) || 0),
                            0
                          )
                          .toFixed(2)
                      )}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {formatReadableAmount(
                        groupedData[godown][group]
                          .reduce(
                            (sum, item) =>
                              sum + (parseFloat(item.sale_val) || 0),
                            0
                          )
                          .toFixed(2)
                      )}
                    </td>

                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default StockBookReport;
